import { styled as e } from "@mui/material";
import s from "../assets/icon-goto-lootrush.png.js";
import i from "./ApeironGotoRoundButton.js";
import { useTranslation as m } from "react-i18next";
import { jsx as p } from "react/jsx-runtime";
const u = e(i)`
  .Custom-Container {
    background-color: #300b7f;
    padding: 3px;

    .Custom-Link {
      :hover {
        background-color: unset;
      }
      .Custom-Icon-Text {
        gap: 8px;
        .Custom-Icon {
          margin-left: 4px;

          ${(o) => o.theme.breakpoints.up("res768")} {
            width: 62px;
          }
          ${(o) => o.theme.breakpoints.down("res768")} {
            width: 44px;
          }
        }
      }
    }
  }
`, g = (o) => {
  const {
    url: t,
    target: r
  } = o, {
    t: n
  } = m();
  return /* @__PURE__ */ p(u, {
    icon: s.toString(),
    url: t,
    target: r,
    text: n("goto.loot_rush")
  });
};
export {
  g as default
};
//# sourceMappingURL=GotoLootRush.js.map
